export const SET_DATA_ON_SLOT = 'SET_DATA_ON_SLOT'
export const EMPTY_SLOT = 'EMPTY_SLOT'
export const SET_ALL_DATA = 'SET_ALL_DATA'